import script from "./TopArticles.vue?vue&type=script&setup=true&lang=js"
export * from "./TopArticles.vue?vue&type=script&setup=true&lang=js"

import "./TopArticles.vue?vue&type=style&index=0&id=bfd1f11a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfd1f11a"]])

export default __exports__